import { makeStyles } from "@material-ui/core/styles";

const useTooltipStyles = makeStyles(() => ({
  tooltip: {
    backgroundColor: "#0C172C",
    color: "#FFFFFF",
    fontFamily: '"Inter", sans-serif',
    fontSize: 14,
    fontWeight: 700,
    lineHeight: "20px",
    maxWidth: 300,
    padding: "8px 16px",
    borderRadius: 4,
  },
  arrow: {
    color: "#0C172C",
  },
}));

export default useTooltipStyles;
